export default __webpack_public_path__ + "static/media/eris.231f8390.jpg";